(function() {
    window.addEventListener('AdsGun::ready', () => {
        function updateAnnouncementBarHeight() {
            const announcementBar = document.querySelector('.shopify-section--announcement-bar');
            if (!announcementBar) return;
            
            const barHeight = announcementBar.offsetHeight;
            document.body.style.setProperty('--announcement-bar-height', `${barHeight}px`, 'important');
        }

        // Run on scroll
        window.addEventListener('scroll', updateAnnouncementBarHeight, { passive: true });
        window.addEventListener('resize', updateAnnouncementBarHeight, { passive: true });

        // Run on load
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', updateAnnouncementBarHeight);
        } else {
            updateAnnouncementBarHeight();
        }

        // Run after a short delay to catch any changes
        setTimeout(updateAnnouncementBarHeight, 100);
        setTimeout(updateAnnouncementBarHeight, 500);

        (function() {
            let savedDrawer = null;

            function cleanupToOne() {
                const drawers = document.querySelectorAll('navigation-drawer');
                if (drawers.length > 1) {
                    for (let i = 0; i < drawers.length - 1; i++) {
                        drawers[i].remove();
                    }
                    console.log('[NavDrawer Fix] Removed', drawers.length - 1, 'duplicate(s)');
                }
                return document.querySelector('navigation-drawer');
            }

            window.addEventListener('click', function(event) {
                let target = event.target;

                if (target.getAttribute('aria-controls') !== 'header-sidebar-menu') {
                    target = target.closest('[aria-controls="header-sidebar-menu"]');
                }

                if (target) {
                    console.log('[NavDrawer Fix] Menu button clicked');

                    setTimeout(function() {
                        let drawers = document.querySelectorAll('navigation-drawer');
                        console.log('[NavDrawer Fix] Found', drawers.length, 'drawer(s)');

                        // Save only once
                        if (!savedDrawer && drawers.length > 0) {
                            savedDrawer = drawers[drawers.length - 1].cloneNode(true);
                            console.log('[NavDrawer Fix] Saved drawer for first time');
                        }

                        // If no drawer exists, restore
                        if (drawers.length === 0 && savedDrawer) {
                            console.log('[NavDrawer Fix] Restoring drawer');
                            document.body.appendChild(savedDrawer.cloneNode(true));
                            return;
                        }

                        // First cleanup
                        cleanupToOne();

                        // Second cleanup after delay (catches late additions)
                        setTimeout(cleanupToOne, 50);

                    }, 100);
                }
            });
        })();
    });
})();

